<ng-select
        [items]="languages"
        bindLabel="label"
        bindValue="code"
        [(ngModel)]="currentLang"
        (change)="changeLanguage($event)"
        [clearable]="false"
        [searchable]="false"
        dropdownPosition="auto"
        class="btn btn-default">

    <!-- Template for the selected item -->
    <ng-template ng-label-tmp let-item="item">
        <span class="flag-icon">{{ item.flag }}</span>
        <span class="label-text">{{ item.code | uppercase }}</span>
    </ng-template>

    <!-- Template for options in the dropdown -->
    <ng-template ng-option-tmp let-item="item" let-index="index">
        <div class="option-wrapper">
            <span class="flag-icon">{{ item.flag }}</span>
            <span class="label-text">{{ item.label }}</span>
        </div>
    </ng-template>
</ng-select>
